module.exports = __webpack_public_path__ + "static/media/expand_your_network.bad33825.jpg";